/* eslint-disable react/jsx-no-bind */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactTimeout from 'react-timeout';
import _ from 'lodash';
import classNames from 'classnames';
import { StickyContainer } from 'react-sticky';
import Tile from 'components/TileLegacy';
import Icon from 'components/Icon';
import { Element } from 'react-scroll';
import { SITE_PLATFORM_MOBILE } from 'helpers/BreakpointHelper';
import { noop } from 'helpers/GlobalHelper';
import { LIVE_EPG_THUMBNAIL_IMAGE, renderImage } from 'helpers/ImageHelper';
import { isVideoLive } from 'components/VideoPlayerGlobal/Helper';
import {
  getTealiumLiveEvents,
  handleTealiumButtonAction,
  setSegmentRestartedPlaybackGlobal,
  TrackEvents,
} from '@foxcorp/delta-web-analytics';
import { nationDigitalChannelEnabled } from 'helpers/ConfigHelper';
import { isElementExist } from 'helpers/ThemeHelper';
import {
  stringToDate,
  format,
  FORMAT_YEAR_MONTH_DAY,
  isBefore,
  addHours,
} from 'helpers/DateTimeHelper';
import {
  isInEPGDateRange,
  isToday,
  getTimezone,
  getVideoData,
  getVideoTimeData,
  getCallSignName,
} from 'screens/Live/LiveHelpers';
import {
  FBN,
  FNC,
  FOX_NATION,
  FOX_WEATHER,
  FOXNEWSTALK,
  NEWSNOW,
  FOXNATIONEVENT,
  FOX_NATION_CHANNEL,
  NOW_PLAYING,
  PRIME_TIME_GRID_SCROLL_PREFIX,
  TILE_IMAGE_LEFT,
} from './constants';
import theme from './NationPrimeTimeGrid.module.scss';
import digitalTheme from './FoxNationDigital.module.scss';

class NationPrimeTimeGrid extends Component {
  constructor(props) {
    super(props);
    const isNationDigitalChannel = nationDigitalChannelEnabled();
    this.state = {
      seeAllClicked: isNationDigitalChannel,
      selectedTab: 'Live Now',
      selectedUpcomingCallSign: '',
      isUpcomingDrownOpen: false,
      isNationDigitalChannel,
      liveItems: null,
    };
  }

  componentDidUpdate(prevProps) {
    const { primeTimePanels, setTimeout } = this.props;
    const { primeTimePanels: prevPrimeTimePanels } = prevProps;
    if (primeTimePanels === prevPrimeTimePanels) return null;
    const primeTimePanelItems = _.get(primeTimePanels, 'member.0.items.member', []);
    let duration = null;

    const fncLiveItems = _.filter(
      primeTimePanelItems,
      item => item.callSign === FNC && item.isLiveNow,
    );
    const nationLiveItems = _.filter(
      primeTimePanelItems,
      item => item.callSign === FOX_NATION && item.isLiveNow,
    );

    if (fncLiveItems.length > 1) {
      duration = new Date(fncLiveItems[1]?.startDate).getTime() - new Date().getTime();
      setTimeout(() => {
        this.setState({ liveItems: _.filter(primeTimePanelItems, item => isVideoLive(item)) });
      }, duration);
    }
    if (nationLiveItems.length > 1) {
      duration = new Date(nationLiveItems[1]?.startDate).getTime() - new Date().getTime();
      setTimeout(() => {
        this.setState({ liveItems: _.filter(primeTimePanelItems, item => isVideoLive(item)) });
      }, duration);
    }

    return null;
  }

  restartClick(video) {
    const { title, subtitleName, callSign } = getVideoData(video);

    const { isCurrent } = getVideoTimeData({ video });

    const { account, resetStillWatchingTimeout } = this.props;

    const { global_restartButton: labelRestart } = window.Language;

    const { [TrackEvents.SCHEDULE_RESTART]: tealiumScheduleRestart } = getTealiumLiveEvents();
    handleTealiumButtonAction({ text: labelRestart, title, subtitle: subtitleName, account });
    tealiumScheduleRestart({ network: callSign });
    if (isCurrent) setSegmentRestartedPlaybackGlobal(true);
    if (resetStillWatchingTimeout) resetStillWatchingTimeout();
  }

  watchLiveClick(video) {
    const { title, subtitleName, callSign } = getVideoData(video);

    const { onChannelSelect, account, resetStillWatchingTimeout, primeTimePanels } = this.props;

    const primeTimePanelItems = _.get(primeTimePanels, 'member.0.items.member', []);
    const channelIndex = _.findIndex(primeTimePanelItems, ['id', video.id]);
    const { isNationDigitalChannel } = this.state;

    const { global_watchLiveButton: labelWatchLive } = window.Language;

    const { [TrackEvents.SCHEDULE_WATCH_LIVE]: tealiumScheduleWatchLive } = getTealiumLiveEvents();
    tealiumScheduleWatchLive({ network: callSign });
    onChannelSelect({
      selectedChannel: channelIndex,
      callSign,
      overrideDigitalChannel: isNationDigitalChannel,
    });
    this.setState({ selectedUpcomingCallSign: callSign, isUpcomingDrownOpen: false });
    handleTealiumButtonAction({ text: labelWatchLive, title, subtitle: subtitleName, account });
    if (resetStillWatchingTimeout) resetStillWatchingTimeout();
  }

  renderDesktopItems(panels, isDateToday) {
    const {
      initialDisplayCount,
      onTitleClick,
      processor,
      breakpoint,
      isAuthenticated,
    } = this.props;
    const { seeAllClicked, isNationDigitalChannel } = this.state;
    const isMobile = breakpoint === SITE_PLATFORM_MOBILE;
    const grid = panels.map((video, itemIndex) => {
      if (
        (!isDateToday && !seeAllClicked) ||
        (initialDisplayCount && !seeAllClicked && itemIndex >= initialDisplayCount)
      ) {
        return null;
      }
      const id = _.get(video, 'id', '');
      const { startDate, isLiveNow } = getVideoData(video);
      const tileClassName = isLiveNow ? classNames(theme.tile, theme.isLiveNow) : theme.tile;
      const d = stringToDate(startDate);
      const startTime = `${format(d, 'h')}:${format(d, 'mm')}${format(d, 'a')} ${getTimezone()}`;
      const startTimeShort = `${format(d, 'h:mm ')}${format(d, 'a').toUpperCase()}`;
      const props = processor({ item: video, isAuthenticated });
      const notificationIconClasses = classNames(
        digitalTheme.notificationIcon,
        props.isNotified && digitalTheme.notificationIconFilled,
      );

      props.onTileClick = () => {
        this.watchLiveClick(video);
      };
      if (isMobile) {
        props.description = startTime;
      }
      props.badge = null;
      props.onTitleClick = onTitleClick;
      props.itemIndex = itemIndex;
      props.shouldDisplayNetworkLogo = true;
      props.isPrimeTime = true;
      props.tileType = TILE_IMAGE_LEFT;
      props.renderImage = image =>
        renderImage({
          breakpoint,
          imageType: LIVE_EPG_THUMBNAIL_IMAGE,
          ...image,
        });
      props.theme = isNationDigitalChannel ? digitalTheme : theme;

      if (!isNationDigitalChannel) {
        return (
          <div className={theme.row} key={id}>
            <div className={tileClassName}>
              <Tile {...props} />
            </div>
            {isMobile ? null : (
              <div className={theme.time}>
                <span>{startTime}</span>
              </div>
            )}
          </div>
        );
      }
      return (
        <div
          className={digitalTheme.upcomingTileContainer}
          role="row"
          tabIndex={0}
          aria-label={props?.title}
        >
          <div className={digitalTheme.upcomingTile}>
            <div className={digitalTheme.showInfo}>
              <div className={notificationIconClasses}>
                {/* TODO Need to add function to notify user */}
                <button onClick={() => {}} className={digitalTheme.notificationButton}>
                  {props.isNotified ? (
                    <Icon icon="bell-filled" viewBox="0 0 26 30" color="white" />
                  ) : (
                    <Icon icon="bell" viewBox="0 0 25 25" color="white" />
                  )}
                </button>
                <span className={digitalTheme.notificationTime}>{startTimeShort}</span>
              </div>
            </div>
            <Tile {...props} />
          </div>
        </div>
      );
    });

    return grid.filter(i => i);
  }

  renderLiveItem(video, liveItemIndex) {
    const id = _.get(video, 'id', '');
    const network = _.get(video, 'network', '');
    const callSign = _.get(video, 'callSign', '');
    const { isLiveNow } = getVideoData(video) || {};
    const { onTitleClick, processor, breakpoint, currentLiveVideo, isAuthenticated } = this.props;
    const { id: currentId, callSign: currentCallsign } = currentLiveVideo || {};
    const isSelected = currentId === id || currentCallsign === callSign;
    const tileClassName =
      isLiveNow && isSelected ? classNames(theme.tile, theme.isLiveNow) : theme.tile;
    const tileContainerClassName = classNames(
      digitalTheme.tileContainer,
      isSelected && digitalTheme.tileContainerActive,
    );
    const { isNationDigitalChannel } = this.state;
    const props = processor({ item: video, isAuthenticated }) || {};
    const isMobile = breakpoint === SITE_PLATFORM_MOBILE;
    const { isLocked } = props;
    const {
      whiteNationLogo,
      whiteFoxNewsLogo,
      whiteFoxWeatherLogo,
      whiteNewsNowLogo,
      whiteFBNLogo,
      whiteFoxNewsRadioLogo,
      whiteFoxNationEventLogo,
    } = window.ExternalConfig;

    let networkIcon;
    if (callSign === FNC) {
      networkIcon = whiteFoxNewsLogo;
    } else if (callSign === FOXNATIONEVENT) {
      networkIcon = whiteFoxNationEventLogo;
    } else if (callSign === FOX_NATION || network === FOX_NATION_CHANNEL) {
      networkIcon = whiteNationLogo;
    } else if (callSign === FOX_WEATHER) {
      networkIcon = whiteFoxWeatherLogo;
    } else if (network === FBN) {
      networkIcon = whiteFBNLogo;
    } else if (callSign === NEWSNOW) {
      networkIcon = whiteNewsNowLogo;
    } else if (callSign === FOXNEWSTALK) {
      networkIcon = whiteFoxNewsRadioLogo;
    }

    props.onTileClick = () => {
      this.watchLiveClick(video);
    };
    props.onTitleClick = onTitleClick;
    props.isPrimeTime = true;
    props.tileType = TILE_IMAGE_LEFT;
    if (isMobile) {
      props.description = NOW_PLAYING;
    }
    props.renderImage = image =>
      renderImage({
        breakpoint,
        imageType: LIVE_EPG_THUMBNAIL_IMAGE,
        ...image,
      });
    props.theme = isNationDigitalChannel ? digitalTheme : theme;
    if (!isNationDigitalChannel) {
      return (
        <div className={classNames(theme.row, theme.liveRow)} key={liveItemIndex}>
          <div className={tileClassName}>
            <Tile {...props} />
          </div>
          {isMobile ? null : (
            <div className={theme.time}>
              <span>Now Playing</span>
            </div>
          )}
        </div>
      );
    }
    return (
      <div
        className={tileContainerClassName}
        onClick={props.onTileClick}
        aria-label={props?.title}
        role="row"
        tabIndex={0}
        key={id}
      >
        <div className={digitalTheme.tileContent}>
          <div className={digitalTheme.showInfo}>
            {isSelected && (
              <>
                {!isLocked ? (
                  <span className={digitalTheme.dot} />
                ) : (
                  <span className={digitalTheme.lock} />
                )}
                <span className={digitalTheme.onNow}>ON NOW</span>
              </>
            )}
            <div className={digitalTheme.networkIconContainerLive}>
              <img alt="network-icon" src={networkIcon} />
            </div>
          </div>
          <Tile {...props} />
        </div>
      </div>
    );
  }

  renderGrid(panels, date) {
    const { isNationDigitalChannel } = this.state;
    if (!isInEPGDateRange(date)) return null;
    const isDateToday = isToday(date);
    const items = this.renderDesktopItems(panels, isDateToday);
    if (!isNationDigitalChannel) {
      return _.isEmpty(items) ? null : (
        <>
          <div className={theme.sectionHeader}>{`${
            isDateToday ? `Today's` : `Tomorrow's`
          } Schedule`}</div>
          {items}
        </>
      );
    }
    return _.isEmpty(items) ? null : (
      <>
        <div className={digitalTheme.digitalSectionHeader}>
          <div
            className={
              isDateToday ? digitalTheme.digitalTodayLine : digitalTheme.digitalTomorrowLine
            }
          />
          <div className={digitalTheme.digitalSectionName}>
            {isDateToday ? 'Today' : 'Tomorrow'}
          </div>
          <div
            className={
              isDateToday ? digitalTheme.digitalTodayLine : digitalTheme.digitalTomorrowLine
            }
          />
        </div>
        {items}
      </>
    );
  }

  handleTabClick = e => {
    this.setState({
      selectedTab: e.target.innerHTML,
    });
  };

  renderUpcomingDropDown = () => {
    const { currentLiveVideo, primeTimePanels } = this.props;
    const { selectedUpcomingCallSign, isUpcomingDrownOpen } = this.state;
    const callSign = selectedUpcomingCallSign || currentLiveVideo?.callSign;
    const channels = _.uniq(
      _.get(primeTimePanels, 'member.0.items.member').reduce(
        (acc, { callSign }) => [...acc, callSign],
        [],
      ),
    ).filter(channel => channel);
    const selectedChannel = channels.find(channel => channel === callSign) || channels[0];
    if (channels.length <= 1) return null;
    const dropdownSelectedButtonClasses = classNames(
      digitalTheme.dropdownSelectedButton,
      isUpcomingDrownOpen ? digitalTheme.dropdownSelectedButtonOpen : null,
    );
    const dropdownContentClasses = classNames(
      digitalTheme.dropdownContent,
      isUpcomingDrownOpen ? digitalTheme.dropdownOpen : digitalTheme.dropdownClosed,
    );
    const getDropdownEntryButtonClasses = index =>
      classNames(
        digitalTheme.dropdownEntryButton,
        index + 1 === channels.length - 1 ? digitalTheme.dropdownEntryButtonLast : null,
      );
    const restChannels = channels.filter(channel => channel !== selectedChannel);
    const selectChannel = channel => {
      this.setState({
        selectedUpcomingCallSign: channel,
        isUpcomingDrownOpen: false,
      });
    };
    return (
      <>
        <div className={digitalTheme.divider} />
        <div className={digitalTheme.dropdownContainer}>
          <div className={digitalTheme.dropdownSelected}>
            <button
              className={dropdownSelectedButtonClasses}
              onClick={() => this.setState({ isUpcomingDrownOpen: !isUpcomingDrownOpen })}
            >
              <div className={digitalTheme.dropdownSelectedEntry}>
                {getCallSignName(selectedChannel)}
              </div>
              <div className={digitalTheme.dropdownSelectedEntryCarot}>
                <Icon icon="chevron-down" viewBox="0 0 11 6" color="white" />
              </div>
            </button>
          </div>
          <div className={dropdownContentClasses}>
            {restChannels.map((channel, index) => (
              <div className={digitalTheme.dropdownEntryContainer}>
                <div className={digitalTheme.dropdownDividerContainer}>
                  <div className={digitalTheme.dropdownDivider} />
                </div>
                <button
                  key={`${channel}${index}`.toString()}
                  onClick={() => selectChannel(channel)}
                  className={getDropdownEntryButtonClasses(index)}
                >
                  <div className={digitalTheme.dropdownEntry}>{getCallSignName(channel)}</div>
                </button>
              </div>
            ))}
          </div>
        </div>
      </>
    );
  };

  renderPrimeTimePanels() {
    const { primeTimePanels, currentLiveVideo } = this.props;
    const {
      seeAllClicked,
      selectedTab,
      isNationDigitalChannel,
      liveItems,
      selectedUpcomingCallSign,
    } = this.state;

    const callSign = selectedUpcomingCallSign || currentLiveVideo?.callSign;
    const now = new Date();
    const tomorrow = addHours(now, 24);
    let panels = _.get(primeTimePanels, 'member.0.items.member');
    if (isNationDigitalChannel) {
      const videoMembers = _.get(primeTimePanels, 'member', []);
      panels = !currentLiveVideo
        ? _.get(primeTimePanels, 'member.1.items.member', [])
        : _.get(
            videoMembers.find(
              panel => panel.callSign === callSign && panel.collectionType === 'upcoming',
            ),
            'items.member',
            [],
          );
    }
    const upcomingDropDown = this.renderUpcomingDropDown();
    const filteredPanels = panels.filter(panel => isBefore(panel.startDate, tomorrow));
    const groupedPanels = _.groupBy(filteredPanels, panel =>
      format(stringToDate(panel.startDate), FORMAT_YEAR_MONTH_DAY),
    );
    const entriesSchedule = obj => Object.keys(obj).map(key => [key, obj[key]]);
    const sortedSchedules = entriesSchedule(groupedPanels).map(([key, schedule]) =>
      this.renderGrid(schedule, key),
    );

    const primeTimePanelItems = _.get(primeTimePanels, 'member.0.items.member', []);
    const livePanelItems = liveItems || _.filter(primeTimePanelItems, item => isVideoLive(item));
    const onClickSeeAll = () => {
      if (!seeAllClicked) {
        this.setState({ seeAllClicked: true });
      }
    };

    let isPreview = false;
    const isPreviewBanner = isElementExist('preview-pass-banner');
    if (isPreviewBanner) {
      isPreview = true;
    } else {
      isPreview = false;
    }

    const currentTheme = theme;

    const gridContainerClasses = classNames(
      currentTheme.gridWrapper,
      isPreview ? digitalTheme.previewPass : '',
    );

    return (
      <StickyContainer>
        <div className={gridContainerClasses} id="grid-wrapper" key="primetime-grid">
          <div className={digitalTheme.tabContainer}>
            <div className={digitalTheme.tabs}>
              <button
                className={selectedTab === 'Live Now' || !selectedTab ? digitalTheme.active : null}
                onClick={this.handleTabClick}
              >
                Live Now
              </button>
              <button
                className={selectedTab === 'Upcoming' ? digitalTheme.active : null}
                onClick={this.handleTabClick}
              >
                Upcoming
              </button>
            </div>
          </div>
          <Element name={`${PRIME_TIME_GRID_SCROLL_PREFIX}`} onScroll={onClickSeeAll}>
            <div className={classNames(selectedTab === 'Upcoming' ? digitalTheme.hide : null)}>
              <div className={digitalTheme.scrollContainer}>
                {livePanelItems.map((video, index) => this.renderLiveItem(video, index))}
              </div>
            </div>
            <div className={classNames(selectedTab !== 'Upcoming' ? digitalTheme.hide : null)}>
              {upcomingDropDown}
              <div className={digitalTheme.scrollContainer}>{sortedSchedules}</div>
            </div>
          </Element>
        </div>
      </StickyContainer>
    );
  }

  render() {
    const { isNationDigitalChannel } = this.state;
    const { primeTimePanels } = this.props;
    if (!primeTimePanels) return null;

    return (
      <div className={isNationDigitalChannel ? digitalTheme.container : theme.container}>
        {this.renderPrimeTimePanels()}
      </div>
    );
  }
}

NationPrimeTimeGrid.defaultProps = {
  account: null,
  coordinates: null,
  favoritesManager: null,
  initialDisplayCount: null,
  isAuthenticated: null,
  isNavScheduleRendered: null,
  onTitleClick: noop,
  overlay: null,
  primeTimePanels: {},
  processor: noop,
  resetStillWatchingTimeout: noop,
  scrollToDateOnMount: true,
  setTimeout: noop,
};

NationPrimeTimeGrid.propTypes = {
  account: PropTypes.shape({}),
  breakpoint: PropTypes.string.isRequired,
  coordinates: PropTypes.shape({}),
  currentLiveVideo: PropTypes.shape({}).isRequired,
  favoritesManager: PropTypes.shape({
    favorites: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    setFavorites: PropTypes.func.isRequired,
    deleteFavorites: PropTypes.func.isRequired,
  }),
  initialDisplayCount: PropTypes.number,
  isAuthenticated: PropTypes.bool,
  isNavScheduleRendered: PropTypes.bool,
  onChannelSelect: PropTypes.func.isRequired,
  onTitleClick: PropTypes.func,
  overlay: PropTypes.string,
  primeTimePanels: PropTypes.shape({}),
  processor: PropTypes.func,
  resetStillWatchingTimeout: PropTypes.func,
  scrollToDateOnMount: PropTypes.bool,
  setOverlay: PropTypes.func.isRequired,
  setSelectedDate: PropTypes.func.isRequired,
  setTimeout: PropTypes.func,
};

export default ReactTimeout(NationPrimeTimeGrid);
